<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 3 :</span> แผนงาน
        </div>

        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              1.แผนการดำเนินงาน (จัดทำในรูปเเบบ Project based management)
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button
              v-if="!isFinal"
              theme="6"
              :disabled="partOneEditMode"
              @onClick="addNewPlan"
            >
              + เพิ่มแผนดำเนินงาน
            </Button>
          </div>

          <!--   PLAN HEADERS   -->
          <div class="py-5 overflow-x-auto mx-n6 px-6 scroll">
            <div class="d-flex justify-space-between gap-8 px-3 mb-3">
              <div class="flex" style="min-width: 42px; max-width: 42px">
                {{ isFinal ? "" : "จัดการ" }}
              </div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                กิจกรรม
              </div>
              <div class="flex" style="min-width: 61px; max-width: 61px">
                WF
              </div>
              <div
                v-for="(m, ind) in shortMonths"
                :key="ind"
                class="flex"
                style="min-width: 43px; max-width: 43px"
              >
                <div class="text-center">{{ m.month }}</div>
                <div class="text-center">{{ m.year }}</div>
              </div>
              <div class="flex" style="min-width: 43px; max-width: 43px">
                แผนผล
              </div>
              <div
                class="flex text-center"
                style="min-width: 43px; max-width: 43px"
              >
                %
              </div>
            </div>

            <!--   PLAN ITEMS   -->
            <div
              v-if="allPlans && allPlans.length > 0"
              class="d-flex flex-column gap-12"
            >
              <div
                v-for="(item, i) in allPlans"
                :key="i"
                class="plan-card d-flex justify-space-between gap-8"
                :class="{
                  'plan-active':
                    partOneEditMode && tempPlan && tempPlan.temp_index === i,
                }"
              >
                <div
                  class="d-flex justify-space-between align-center"
                  style="min-width: 42px; max-width: 42px"
                >
                  <v-btn v-if="!isFinal" small icon @click="editPlan(i)">
                    <Iconify
                      icon="material-symbols:edit"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                  <v-btn v-if="!isFinal" small icon @click="deletePlan(i)">
                    <Iconify
                      icon="material-symbols:delete"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
                <div class="d-block">
                  <div
                    class="flex two-line"
                    style="min-width: 120px; max-width: 120px; max-height: 45px"
                  >
                    <tooltip-text :text="item.p1_activity_name" />
                  </div>
                </div>
                <!-- <div
                  class="flex two-line"
                  style="min-width: 120px; max-width: 120px; max-height: 45px"
                >
                  {{ item.p1_activity_name }}
                </div> -->
                <div
                  class="flex d-flex justify-space-between"
                  style="min-width: 61px; max-width: 61px; height: 54px"
                >
                  <v-divider vertical></v-divider>
                  <div
                    class="tiny-field tf-active"
                    style="min-width: 40px; max-width: 40px; height: 100%"
                  >
                    {{ item.p1_wf }}
                  </div>
                  <v-divider vertical></v-divider>
                </div>
                <div
                  v-for="(m, ind) in shortMonths"
                  :key="ind"
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[ind].month_value
                        ? item.project_section_plan_month[ind].month_value
                        : "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      item.project_section_plan_month[ind].actual_month_value
                        ? item.project_section_plan_month[ind]
                            .actual_month_value
                        : "-"
                    }}
                  </div>
                </div>

                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]?.month_value ||
                      "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]
                        ?.actual_month_value || "-"
                    }}
                  </div>
                </div>
                <div
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[shortMonths.length - 1]
                        ?.month_value || "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      formatNumber(
                        parseFloat(
                          item.project_section_plan_month[currIndex]
                            ?.actual_month_value * 100
                        ) /
                          parseFloat(
                            item.project_section_plan_month[currIndex]
                              ?.month_value
                          ),
                        2
                      )
                    }}
                  </div>
                </div>
              </div>

              <!--   SUMMARY   -->
              <div class="plan-card">
                <div class="d-flex justify-space-between gap-8">
                  <div
                    class="flex"
                    style="min-width: 42px; max-width: 42px"
                  ></div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    แผนงานถ่วงน้ำหนัก
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div
                      class="tiny-field"
                      :class="{
                        'theme-color-four tf-error': totalWF() !== '1.00',
                      }"
                      style="min-width: 40px; max-width: 40px"
                    >
                      {{ totalWF() }}
                    </div>
                    <v-divider vertical></v-divider>
                  </div>

                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(ind) }}
                  </div>

                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(currIndex) }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ weightPlan(shortMonths.length - 1) }}
                  </div>
                </div>

                <v-divider class="my-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div
                    class="flex"
                    style="min-width: 42px; max-width: 42px"
                  ></div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    ผลการดำเนินงาน
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{ isFinal ? weightPlan(ind, "actual_month_value") : "-" }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? weightPlan(currIndex, "actual_month_value")
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              weightPlan(currIndex, "actual_month_value") * 100
                            ) / parseFloat(weightPlan(currIndex)),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>

                <v-divider class="mt-3"></v-divider>

                <div class="d-flex justify-space-between align-center gap-8 py-3"
                    :class="{ 'bg-error': !validatePlanBudget() }" 
                >
                  <div class="flex" style="min-width: 42px; max-width: 42px">
                    <v-btn
                      v-if="budget_amount !== 0 && !isFinal"
                      small
                      icon
                      @click="editBudgetPlan()"
                    >
                      <Iconify
                        icon="material-symbols:edit"
                        color="var(--theme-color-seven)"
                      ></Iconify>
                    </v-btn>
                  </div>
                  <div class="flex mt-0.5" style="min-width: 120px; max-width: 120px">
                    แผนการใช้จ่ายจริง
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px ;height: 24px;"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      budgetPlans[ind]?.plan_budget_rate
                        ? budgetPlans[ind].plan_budget_rate
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      budgetPlans[currIndex]?.plan_budget_rate
                        ? budgetPlans[currIndex].plan_budget_rate
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      budgetPlans[shortMonths.length - 1]?.plan_budget_rate
                        ? budgetPlans[shortMonths.length - 1].plan_budget_rate
                        : "-"
                    }}
                  </div>
                </div>

                <v-divider class="mb-3"></v-divider>

                <div class="d-flex justify-space-between gap-8">
                  <div
                    class="flex"
                    style="min-width: 42px; max-width: 42px"
                  ></div>
                  <div class="flex" style="min-width: 120px; max-width: 120px">
                    การใช้จ่ายจริง
                  </div>
                  <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px"
                  >
                    <v-divider vertical></v-divider>
                    <div style="min-width: 40px; max-width: 40px"></div>
                    <v-divider vertical></v-divider>
                  </div>
                  <div
                    v-for="(m, ind) in shortMonths"
                    :key="ind"
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal && budgetPlans[ind]?.use_budget_rate
                        ? formatNumber(budgetPlans[ind].use_budget_rate, 2)
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal && budgetPlans[currIndex]?.use_budget_rate
                        ? formatNumber(
                            budgetPlans[currIndex].use_budget_rate,
                            2
                          )
                        : "-"
                    }}
                  </div>
                  <div
                    class="flex tiny-field"
                    style="min-width: 43px; max-width: 43px"
                  >
                    {{
                      isFinal
                        ? formatNumber(
                            parseFloat(
                              budgetPlans[currIndex]?.use_budget_rate * 100
                            ) /
                              parseFloat(
                                budgetPlans[currIndex]?.plan_budget_rate
                              ),
                            2
                          )
                        : "-"
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
        </div>
      </div>

      <div
        v-if="partOneEditMode && !isFinal"
        id="part-one-edit"
        class="card-part"
      >
        <div class="d-flex gap-16 mb-3">
          <div>
            <div class="black--text mb-3">กิจกรรม</div>

            <TextField
              theme="3"
              :value="tempPlan.p1_activity_name"
              @onChange="tempPlan.p1_activity_name = $event"
            ></TextField>
          </div>
          <div>
            <div class="black--text mb-3">WF</div>

            <TextField
              theme="3"
              input-type="decimal"
              :value="tempPlan.p1_wf"
              :error="error_p1_wf"
              @onChange="tempPlan.p1_wf = $event"
            ></TextField>
          </div>
        </div>
        <div class="plan-field-form">
          <div v-for="(month, i) in shortMonths" :key="i">
            <div class="text-center mb-2">
              {{ month.month }} {{ month.year }}
            </div>
            <TextField
              theme="3"
              input-type="decimal-100"
              :error="
                tempPlan.project_section_plan_month[i]?.error ||
                tempPlan.project_section_plan_month[i]?.errorSkipInput
              "
              :disabled="nowIndex(month.month, month.year)"
              :readonly="nowIndex(month.month, month.year)"
              :value="tempPlan.project_section_plan_month[i]?.month_value"
              @onChange="validateInput(i, $event)"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button min-width="80px" theme="2" @onClick="partOneEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="savePlan"
            >ยืนยัน
          </Button>
        </div>
      </div>
      <div
        v-if="partOneBudgetEditMode && !isFinal"
        id="part-one-budget-edit"
        class="card-part"
      >
        <div class="d-flex gap-16 mb-3">
          แผนการใช้จ่าย<span
            class="theme-color-seven txt-normal"
            style="margin-left: -10px"
            >(บาท)</span
          >
        </div>
        <div class="plan-field-form">
          <div v-for="(month, i) in shortMonths" :key="i">
            <div class="text-center mb-2">
              {{ month.month }} {{ month.year }}
            </div>
            <TextField
              theme="3"
              input-type="decimal"
              :error="
                tempBudgetPlan[i]?.error || tempBudgetPlan[i]?.errorSkipInput
              "
              isFormat
              :disabled="nowIndex(month.month, month.year)"
              :readonly="nowIndex(month.month, month.year)"
              :value="tempBudgetPlan[i]?.plan_budget"
              @onChange="tempBudgetPlan[i].plan_budget = $event"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button
            min-width="80px"
            theme="2"
            @onClick="partOneBudgetEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveBudgetPlan"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <div class="mb-5">
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              2. งบประมาณ (รายละเอียดการประเมินค่าใช้จ่ายในโครงการ)
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button
              v-if="!isFinal"
              theme="6"
              :disabled="partTwoEditMode"
              @onClick="addNewBudget"
            >
              + เพิ่มรายละเอียดงบประมาณ
            </Button>
          </div>

          <div class="d-flex theme-color-eight px-3 mb-3 gap-12">
            <div style="width: 8%">{{ isFinal ? "" : "จัดการ" }}</div>
            <div style="width: 10%">รายการ</div>
            <div style="width: 22%">รายละเอียด</div>
            <div class="text-end" style="width: 15%">
              สนับสนุนโดยภาคเอกชน<br />In-kind
            </div>
            <div class="text-end" style="width: 15%">
              สนับสนุนโดยภาคเอกชน<br />In-cash
            </div>
            <div class="text-end" style="width: 15%">
              สนับสนุนโดย<br />อุทยานวิทยาศาสตร์
            </div>
            <div class="text-end" style="width: 15%">รวม</div>
          </div>

          <div class="d-flex flex-column gap-16">
            <div v-for="(item, i) in budgetList" :key="i" class="budget-item">
              <div
                class="d-flex justify-space-between align-center black--text gap-12"
              >
                <div style="width: 8%">
                  <v-btn v-if="!isFinal" small icon @click="editBudget(i)">
                    <Iconify
                      icon="material-symbols:edit"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                  <v-btn v-if="!isFinal" small icon @click="deleteBudget(i)">
                    <Iconify
                      icon="material-symbols:delete"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
                <div style="width: 10%">{{ item.budget_name }}</div>
                <div
                  style="width: 25%"
                  v-html="item.budget_detail?.replace(/\n/g, '<br>')"
                ></div>
                <div class="text-end" style="width: 10%">
                  {{ formatNumber(item.budget_in_kind, 2) }}
                </div>
                <div class="text-end" style="width: 10%">
                  {{ formatNumber(item.budget_in_cash, 2) }}
                </div>
                <div class="text-end" style="width: 19%">
                  {{ formatNumber(item.budget_sci_park, 2) }}
                </div>
                <div class="text-end" style="width: 18%">
                  {{ formatNumber(item.budget_sum, 2) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="budgetList && budgetList.length > 0"
          class="d-flex flex-column gap-12 px-12 mb-5"
        >
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมลำดับที่ 1-{{ budgetList.length }}</div>
            <div class="theme-color-one">
              {{
                formatNumber(
                  budgetList
                    .map((x) => x.budget_sum)
                    .reduce((a, b) => parseFloat(a) + parseFloat(b), 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="black--text">รวมงบสนับสนุนโดยภาคเอกชน เป็นเงิน</div>
            <div class="theme-color-one">
              {{
                formatNumber(
                  budgetList
                    .map(
                      (x) =>
                        parseFloat(x.budget_in_kind) +
                        parseFloat(x.budget_in_cash)
                    )
                    .reduce((a, b) => a + b, 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
          <div class="d-flex justify-space-between">
            <div class="black--text">
              รวมงบสนับสนุนโดยอุทยานวิทยาศาสตร์ เป็นเงิน
            </div>
            <div class="theme-color-one">
              {{
                formatNumber(
                  budgetList
                    .map((x) => parseFloat(x.budget_sci_park))
                    .reduce((a, b) => a + b, 0),
                  2
                )
              }}
              บาท
            </div>
          </div>
          <!--          <div class="d-flex justify-space-between">-->
          <!--            <div class="black&#45;&#45;text">รวมค่าใช้จ่ายสุทธิ</div>-->
          <!--            <div class="theme-color-one">{{ formatNumber(budgetList.map(x => x.budget_sum).reduce((a, b) => a + b, 0), 2) }} บาท</div>-->
          <!--          </div>-->
        </div>

        <div class="remark-box">
          หมายเหตุ :
          <div>
            * ค่าตอบแทนของคณะทำงาน ไม่เกินร้อยละ 30 ของงบประมาณโครงการทั้งหมด
          </div>
          <div>
            * ทรัพยากรที่จำเป็น (In-kind) ไม่เกินร้อยละ 50 ของงบประมาณ (In-cash)
            ที่ภาคเอกชนสนับสนุน
          </div>
          <div>
            * ภาคเอกชนต้องออก (In-kind + In-cash) อย่างน้อยร้อยละ 50
            หรือมากกว่าร้อยละ 50 ของยอดเงิน งบประมาณทั้งหมด
          </div>
        </div>
      </div>

      <div
        v-if="partTwoEditMode && !isFinal"
        id="part-two-edit"
        class="card-part"
      >
        <div class="d-flex gap-16 mb-3" style="align-items: end">
          <div>
            <div class="black--text mb-3">รายการ</div>

            <TextField
              theme="3"
              :value="tempBudget.budget_name"
              @onChange="tempBudget.budget_name = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">
              สนับสนุนโดยภาคเอกชน<br />
              In-kind
            </div>
            <TextField
              theme="3"
              input-type="decimal"
              isFormat
              :value="tempBudget.budget_in_kind"
              @onChange="tempBudget.budget_in_kind = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">
              สนับสนุนโดยภาคเอกชน<br />
              In-cash
            </div>
            <TextField
              theme="3"
              input-type="decimal"
              isFormat
              :value="tempBudget.budget_in_cash"
              @onChange="tempBudget.budget_in_cash = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">
              สนับสนุนโดย<br />
              อุทยานวิทยาศาสตร์
            </div>

            <TextField
              theme="3"
              input-type="decimal"
              isFormat
              :value="tempBudget.budget_sci_park"
              @onChange="tempBudget.budget_sci_park = $event"
            ></TextField>
          </div>
        </div>

        <div>
          <div>
            <div class="black--text mb-3">รายละเอียด</div>

            <TextArea
              theme="3"
              :value="tempBudget.budget_detail"
              @onChange="tempBudget.budget_detail = $event"
            ></TextArea>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button min-width="80px" theme="2" @onClick="partTwoEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveBudget"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>

    <div v-if="plan_code === 'IRTC'" class="d-flex flex-column gap-12 mb-6">
      <divcard>
        <div class="card-part pt-0">
          <div>
            <div class="txt-head black--text d-flex justify-space-between mb-3">
              <div>
                3. ตารางสรุปแผนการดําเนินงาน
                <span class="theme-color-seven txt-normal"
                  >(ข้อมูลจากข้อที่ 1)</span
                >
              </div>
              <!--            <Button-->
              <!--                theme="6"-->
              <!--                :disabled="partThreeEditMode"-->
              <!--                @onClick="addNewPlanDetail"-->
              <!--            >-->
              <!--              + เพิ่มรายละเอียดแผนงาน-->
              <!--            </Button>-->
            </div>

            <!--   HEADERS   -->
            <div class="d-flex px-13 mb-5">
              <div class="flex" style="min-width: 230px; max-width: 230px">
                กิจกรรม
              </div>

              <div
                class="flex mx-3"
                style="min-width: 1px; max-width: 1px"
              ></div>

              <div class="d-flex justify-space-between" style="width: 100%">
                <div
                  v-for="(m, ind) in shortMonths"
                  :key="ind"
                  class="flex"
                  style="min-width: 45px"
                >
                  <div class="text-center">{{ m.month }}</div>
                  <!--              <div class="text-center">65</div>-->
                </div>
              </div>
            </div>

            <!--   ITEMS   -->
            <div class="d-flex flex-column gap-16">
              <div
                v-for="(item, i) in allProgressPlan"
                :key="i"
                class="summary-plan"
              >
                <div class="d-flex black--text">
                  <div
                    class="mr-2"
                    style="min-width: 30px; max-width: 30px"
                  ></div>

                  <div
                    class="two-line"
                    style="min-width: 230px; max-width: 230px"
                  >
                    {{ item.activity_name }}
                  </div>

                  <v-divider
                    class="mx-3"
                    vertical
                    style="height: 54px"
                  ></v-divider>

                  <div class="flex plan-slot d-flex pr-10">
                    <div
                      v-for="(m, ind) in shortMonths"
                      :key="ind"
                      class="flex"
                      :class="{
                        'progress-plan-mark': item.plan.includes(m.key),
                        'start-point':
                          Math.min.apply(null, item.plan) === m.key,
                        'end-point': Math.max.apply(null, item.plan) === m.key,
                      }"
                    >
                      <v-divider v-if="item.plan.includes(m.key)"></v-divider>
                      <div class="white--text arrow-right">&gt;</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="partThreeEditMode" class="card-part">
          <div class="d-flex gap-16 mb-3">
            <div>
              <div class="black--text mb-3">กิจกรรม</div>

              <TextField
                theme="3"
                :value="tempProgressPlan.p3_act_name"
                @onChange="tempProgressPlan.p3_act_name = $event"
              ></TextField>
            </div>

            <div>
              <div class="black--text mb-3">หมายเหตุ</div>

              <TextField
                theme="3"
                :value="tempProgressPlan.p3_remark"
                @onChange="tempProgressPlan.p3_remark = $event"
              ></TextField>
            </div>
          </div>

          <div class="d-flex justify-space-between mb-5 px-6">
            <div v-for="(item, i) in shortMonths" :key="i">
              <div class="black--text mb-1">{{ item.month }}</div>
              <CheckBox
                color="var(--theme-color-three)"
                :input-value="tempProgressPlan.plan.includes(item.key)"
                @onChange="progressPlanCheck(item.key)"
              ></CheckBox>
            </div>
          </div>

          <div class="d-flex justify-end gap-16">
            <Button
              min-width="80px"
              theme="2"
              @onClick="partThreeEditMode = false"
              >ยกเลิก
            </Button>

            <Button min-width="80px" theme="6" @onClick="saveProgressPlan"
              >ยืนยัน
            </Button>
          </div>
        </div>
      </divcard>

      <divcard v-if="isFinal">
        <div class="card-part pt-0">
          <div>
            <div class="mb-3">
              <span class="black--text txt-head"
                >4. ปัญหาและอุปสรรคจากการดำเนินงาน</span
              >
              <span
                class="theme-color-seven txt-normal"
                style="text-indent: 16px"
                >(โปรดระบุ)</span
              >
            </div>
            <TextArea
              theme="3"
              height="100"
              :value="project_section.s3_problem"
              @onChange="setFormField('s3_problem', $event)"
            ></TextArea>
          </div>
        </div>
      </divcard>

      <divcard v-if="isFinal">
        <div class="card-part pt-0">
          <div>
            <div class="mb-3">
              <span class="black--text txt-head">5. แนวทางในการแก้ไขปัญหา</span>
              <span
                class="theme-color-seven txt-normal"
                style="text-indent: 16px"
                >(โปรดระบุ)</span
              >
            </div>
            <TextArea
              theme="3"
              height="100"
              :value="project_section.s3_solution"
              @onChange="setFormField('s3_solution', $event)"
            ></TextArea>
          </div>
        </div>
      </divcard>
    </div>

    <div v-if="plan_code === 'CR'" class="d-flex flex-column gap-12 mb-6">
      <divcard>
        <div class="card-part pt-0">
          <div>
            <div class="txt-head black--text mb-3">
              3. การจัดการทรัพย์สินทางปัญญา (ถ้ามี)
            </div>
            <Wysiwyg
              theme="3"
              :value="project_section.s3_p3_ip_management"
              @onChange="setFormField('s3_p3_ip_management', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </divcard>

      <divcard v-if="isFinal">
        <div class="card-part pt-0">
          <div>
            <div class="mb-3">
              <span class="black--text txt-head"
                >4. ปัญหาและอุปสรรคจากการดำเนินงาน </span
              >
              <span
                class="theme-color-seven txt-normal"
                style="text-indent: 16px"
                >(โปรดระบุ)</span
              >
            </div>
            <Wysiwyg
              theme="3"
              :value="project_section.s3_p3_problem"
              @onChange="setFormField('s3_p3_problem', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </divcard>

      <divcard v-if="isFinal">
        <div class="card-part pt-0">
          <div>
            <div class="mb-3">
              <span class="black--text txt-head">5. แนวทางในการแก้ไขปัญหา </span>
              <span
                class="theme-color-seven txt-normal"
                style="text-indent: 16px"
                >(โปรดระบุ)</span
              >
            </div>
            <Wysiwyg
              theme="3"
              :value="project_section.s3_p3_solution"
              @onChange="setFormField('s3_p3_solution', $event)"
            ></Wysiwyg>
          </div>
        </div>
      </divcard>

      <divcard v-if="isFinal">
      <div class="card-part pt-0">
        <div>
          <div class="mb-3">
            <span class="black--text txt-head"
              >6.
              ความสนใจในการใช้บริการอื่นๆของอุทยานวิทยาศาสตร์ภูมิภาคในอนาคต </span
            >
            <span class="theme-color-seven txt-normal" style="text-indent: 16px"
              >(โปรดระบุ)</span
            >
          </div>
          <AutoBox
            theme="3"
            :items="interest_list"
            multiple
            chips
            deletable-chips
            :value="project_section.s3_p3_interest"
            @onChange="setFormField('s3_p3_interest', $event)"
          ></AutoBox>
        </div>
      </div>
    </divcard>

    </div>

    <!-- Role: CR, IRTC => 4. รายละเอียดการส่งมอบงาน -->
    <div v-if=" plan_code === 'CR' || (plan_code === 'IRTC' && !isFinal )">
      <divcard>
        <v-layout justify-space-between align-center>
          <v-flex shrink>
            <div class="txt-head black--text mb-3">
              <div>{{ isFinal ? '7' : '4'}}. รายละเอียดการส่งมอบงาน</div>
              <div class="theme-color-seven txt-normal">
                (โปรดระบุจำนวนวันส่งรายงานความก้าวหน้าและรายงานฉบับสมบูรณ์
                อ้างอิงจากกิจกรรมการดำเนินงาน)
              </div>
            </div>
          </v-flex>
          <v-flex shrink>
            <Button
              theme="6"
              :disabled="partTwoEditMode"
              @onClick="is_job_delivery_details_form = true"
            >
              + เพิ่มรายละเอียดการส่งมอบงาน
            </Button>
          </v-flex>
        </v-layout>

        <!-- header table -->
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  width="10%"
                  class="font-14 font-w-400 text-center"
                  style="border-bottom: 0px"
                >
                  จัดการ
                </th>
                <th
                  width="10%"
                  class="font-14 font-w-400 text-center"
                  style="border-bottom: 0px"
                >
                  งวดที่
                </th>
                <th
                  width="20%"
                  class="font-14 font-w-400 text-center"
                  style="border-bottom: 0px"
                >
                  ภายใน (วัน)
                </th>
                <th
                  width="20%"
                  class="font-14 font-w-400 text-center"
                  style="border-bottom: 0px"
                >
                  ร้อยละการเบิกจ่าย (%)
                </th>
                <th
                  width="40%"
                  class="font-14 font-w-400"
                  style="border-bottom: 0px"
                >
                  รายละเอียดงานที่ต้องส่งมอบ
                </th>
              </tr>
            </thead>
          </template>
        </v-simple-table>

        <!-- body table -->
        <div v-if="job_delivery_details.length > 0">
          <v-card
            v-for="(
              job_delivery_detail, job_delivery_detail_index
            ) in job_delivery_details"
            :key="job_delivery_detail_index"
            class="mb-4"
            style="border-radius: 20px; box-shadow: 1px 1px 30px 0px #0000001a"
          >
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td
                      width="10%"
                      class="text-center"
                      style="border-bottom: 0px"
                    >
                      <v-btn
                        icon
                        @click="
                          editIncubationCompany(job_delivery_detail_index)
                        "
                      >
                        <v-icon color="#F15A29"> mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        icon
                        @click="
                          deleteIncubationCompany(job_delivery_detail_index)
                        "
                      >
                        <v-icon color="#B1B1B1"> mdi-delete</v-icon>
                      </v-btn>
                    </td>
                    <td
                      width="10%"
                      class="text-center"
                      style="border-bottom: 0px"
                    >
                      {{ job_delivery_detail.installment }}
                    </td>
                    <td
                      width="20%"
                      class="text-center"
                      style="border-bottom: 0px"
                    >
                      {{ job_delivery_detail.installment_date }}
                    </td>
                    <td
                      width="20%"
                      class="text-center"
                      style="border-bottom: 0px"
                    >
                      {{ job_delivery_detail.installment_percent }}
                    </td>
                    <td width="40%" style="border-bottom: 0px; overflow-wrap: anywhere">
                      {{ job_delivery_detail.installment_detail }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </div>

        <div v-else>
          <v-card
            class="mb-4"
            style="
              border-radius: 20px;
              box-shadow: 1px 1px 30px 0px #0000001a;
              color: #b1b1b1;
            "
          >
            <div class="text-center py-4">ไม่มีข้อมูล</div>
          </v-card>
        </div>

        <!-- Form เพิ่มรายละเอียดการส่งมอบงาน -->
        <transition name="fade">
          <v-form
            class="mt-6 job_delivery_details_form"
            ref="job_delivery_details_form"
            v-model="valid_job_delivery_details"
            lazy-validation
            v-if="is_job_delivery_details_form"
          >
            <v-divider />

            <div class="my-3">
              <v-icon> mdi-pencil </v-icon>
              {{ jobDeliveryDetailsIndex !== null ? "แก้ไข" : "เพิ่ม" }}
            </div>

            <v-row>
              <v-col cols="4">
                <label>งวดที่</label>
                <v-text-field
                  v-model="job_delivery_details_form.installment"
                  outlined
                  color="#F15A29"
                  type="number"
                  rounded
                  :rules="[(v) => !!v || 'กรุณาระบุงวดที่']"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label>ภายใน (วัน)</label>
                <v-text-field
                  v-model="job_delivery_details_form.installment_date"
                  outlined
                  color="#F15A29"
                  type="number"
                  rounded
                  :rules="[(v) => !!v || 'กรุณาระบุภายใน (วัน)']"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <label>ร้อยละการเบิกจ่าย (%)</label>
                <v-text-field
                  v-model="job_delivery_details_form.installment_percent"
                  outlined
                  color="#F15A29"
                  type="number"
                  rounded
                  :rules="[(v) => !!v || 'กรุณาระบุร้อยละการเบิกจ่าย (%)']"
                ></v-text-field>
              </v-col>
            </v-row>

            <label>รายละเอียดงานที่ต้องส่งมอบ</label>
            <v-text-field
              v-model="job_delivery_details_form.installment_detail"
              outlined
              color="#F15A29"
              rounded
              :rules="[(v) => !!v || 'กรุณาระบุรายละเอียดงานที่ต้องส่งมอบ']"
            ></v-text-field>

            <div class="d-flex justify-end gap-16">
              <Button
                min-width="80px"
                theme="2"
                @onClick="clearJobDeliveryDetailsForm"
              >
                ยกเลิก
              </Button>

              <Button
                min-width="80px"
                theme="6"
                @onClick="handleSubmitJobDeliveryDetailsForm"
              >
                ยืนยัน
              </Button>
            </div>
          </v-form>
        </transition>
      </divcard>
    </div>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import Button from "../../../components/input/Button";
import CheckBox from "../../../components/input/CheckBox";
import { eventBus, formatNumber } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import { format } from "date-fns";
import { th } from "date-fns/locale";
import Wysiwyg from "@/components/input/Wysiwyg.vue";


export default {
  name: "CFormPlan",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    CheckBox,
    Button,
    Wysiwyg,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      form: {},
      currIndex: 0,
      tempPlan: {},
      tempBudgetPlan: {},
      tempBudget: {},
      tempProgressPlan: {},
      partOneEditMode: false,
      partOneBudgetEditMode: false,
      partTwoEditMode: false,
      partThreeEditMode: false,
      project_section: null,
      allPlans: [],
      budgetPlans: [],
      shortMonths: [],
      plan_prototype: {
        p1_wf: "",
        project_section_plan_month: [],
      },
      budget_plan_prototype: [],
      progressPlan_prototype: {
        plan: [],
      },
      error_p1_wf: false,
      allProgressPlan: [],
      allEventsName: [
        "ส่งเสริมคุณภาพการออกแบบและพัฒนา",
        "พัฒนาระบบด้านเทคโนโลยีของหุ่นยนต์",
      ],
      budgetList: [],
      budget_amount: 0,
      fiscalYear: new Date().getFullYear() + 543,
      plan_code: "",

      // job_delivery_details
      is_job_delivery_details_form: false,
      job_delivery_details: [
        // {
        //   installment: "1000",
        //   installment_date: "10",
        //   installment_percent: "1",
        //   installment_detail: "Test 1",
        // },
        // {
        //   installment: "2000",
        //   installment_date: "20",
        //   installment_percent: "2",
        //   installment_detail: "Test 2",
        // },
      ],
      valid_job_delivery_details: true,
      job_delivery_details_form: {
        installment: "",
        installment_date: "",
        installment_percent: "",
        installment_detail: "",
      },
      jobDeliveryDetailsIndex: null,
      interest_list: [
        "Service Platform",
        "Business Incubation",
        "IRTC",
        "Co-Research",
      ],

    };
  },
  computed: {
    ...mapState({
      PlanForm: (state) => state.CForm.PlanForm,
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
    finalDayError() {
      if (
        this.project_section.s3_p4_progress_day &&
        this.project_section.s3_p4_final_day
      )
        return (
          parseInt(this.project_section.s3_p4_final_day) <=
          parseInt(this.project_section.s3_p4_progress_day)
        );
      else return false;
    },

  },
  created() {
    this.clearTempPlan();
    this.clearTempProgressPlan();
    console.log("currIndex", this.currIndex);

    // Load from store if available
    const storedPlanForm = this.$store.state.CForm.PlanForm;
    if (storedPlanForm && storedPlanForm.job_delivery_details) {
      this.job_delivery_details = storedPlanForm.job_delivery_details;
    }

    if (this.isSameId && !this.masterData.form_c) this.form = this.PlanForm;
    if (this.masterData.form_c) {
      this.setData();
      this.plotProgressPlanGraphData();
      for (const x of this.allPlans) {
        x.percent = this.getLastProgress(x.project_section_plan_month);
      }
    }
    // set begin budget year month
    this.setupBudgetYearMonth();
    if (this.budgetPlans.length === 0) {
      this.budgetPlans = this.budget_plan_prototype;
    }
    this.currIndex = this.getCurrIndex();

    eventBus.$on("cFormPlan", () => {
      eventBus.$emit("cFormPlanSend", {
        ...this.project_section,
        project_section_plan_p1: this.allPlans.map((x) => ({
          ...x,
          percent: undefined,
        })),
        project_section_plan_p1_budget: this.budgetPlans,
        project_section_budget: this.budgetList,
        budget_amount: this.budget_amount,
        job_delivery_details: this.job_delivery_details,
      });
    });

    eventBus.$on("cFormPlanSetData", () => this.setData());
  },
  methods: {
    clearJobDeliveryDetailsForm() {
      this.job_delivery_details_form = {
        installment: "",
        installment_date: "",
        installment_percent: "",
        installment_detail: "",
      };
      this.jobDeliveryDetailsIndex = null;
      this.is_job_delivery_details_form = false;
    },

    handleSubmitJobDeliveryDetailsForm() {
      if (this.$refs.job_delivery_details_form.validate()) {
        if (this.jobDeliveryDetailsIndex != null) {
          this.updateJobDeliveryDetails();
        } else {
          this.saveJobDeliveryDetails();
        }
      }
    },

    saveJobDeliveryDetails() {
      console.log("saveJobDeliveryDetails");
      this.job_delivery_details.push(this.job_delivery_details_form);

      this.clearJobDeliveryDetailsForm();
    },

    updateJobDeliveryDetails() {
      console.log("updateJobDeliveryDetails", this.jobDeliveryDetailsIndex);
      this.job_delivery_details[this.jobDeliveryDetailsIndex] =
        this.job_delivery_details_form;
      this.clearJobDeliveryDetailsForm();
    },

    editIncubationCompany(index) {
      console.log("editIncubationCompany", index);
      this.job_delivery_details_form = {
        ...this.job_delivery_details[index],
      };
      this.jobDeliveryDetailsIndex = index;
      this.is_job_delivery_details_form = true;
    },

    deleteIncubationCompany(index) {
      console.log("deleteIncubationCompany", index);
      this.job_delivery_details.splice(index, 1);
    },

    setFormField(field, val) {
      this.project_section[field] = val;
      this.$forceUpdate();
    },
    setData() {
      this.project_section = this.masterData.form_c.project_section;
      this.allPlans =
        this.masterData.form_c.project_section_plan?.project_plan_p1 || [];
      this.budgetPlans =
        this.masterData.form_c.project_section_plan
          ?.project_section_plan_p1_budget || [];
      console.log("budgetPlans", this.budgetPlans);
      this.budgetList =
        this.masterData.form_c.project_section_plan?.project_section_budget ||
        [];

      
      this.fiscalYear = this.masterData.form_c.fiscal_year;
      this.calcBudgetAmount();

      this.plan_code = this.masterData.plan_master.plan_code || "";

      //   if (this.plan_code === "CR")
      //     this.project_section.s3_p3_ip_management =
      //       this.masterData.form_c.project_section.s3_p3_ip_management;

      if (this.plan_code === "CR" || this.plan_code === "IRTC") {
        // Prefer store data over masterData if store has newer data
        const storedPlanForm = this.$store.state.CForm.PlanForm;
        if (storedPlanForm && storedPlanForm.job_delivery_details && storedPlanForm.job_delivery_details.length > 0) {
          this.job_delivery_details = storedPlanForm.job_delivery_details;
        } else {
          this.job_delivery_details = this.masterData.form_c?.job_delivery_details || [];
        }
      }

      // Emit updated data to FormC after setData
      this.$nextTick(() => {
        eventBus.$emit("cFormPlanSend", {
          ...this.project_section,
          project_section_plan_p1: this.allPlans.map((x) => ({
            ...x,
            percent: undefined,
          })),
          project_section_plan_p1_budget: this.budgetPlans,
          project_section_budget: this.budgetList,
          budget_amount: this.budget_amount,
          job_delivery_details: this.job_delivery_details,
        });
      });
    },
    plotProgressPlanGraphData() {
      let allPG = [];
      if (this.allPlans.length > 0) {
        this.allPlans.forEach((plan) => {
          let PG = {
            activity_name: plan.p1_activity_name,
            plan: [],
          };
          if (
            plan.project_section_plan_month &&
            plan.project_section_plan_month.length > 0
          ) {
            let month_plans = [];
            let is_end = false;
            plan.project_section_plan_month.forEach((month, index) => {
              if (
                month.month_value !== null &&
                parseFloat(month.month_value) !== 100.0
              )
                month_plans.push(index + 1);
              else if (parseFloat(month.month_value) === 100.0 && !is_end) {
                month_plans.push(index + 1);
                is_end = true;
              }
            });
            PG.plan = month_plans;
          }
          allPG.push(PG);
        });
      }

      console.log("allPG", allPG);
      this.allProgressPlan = allPG;
    },
    mapWFData() {
      this.shortMonths.forEach((m, i) => {
        this.budgetPlans[i].month_value = this.weightPlan(i);
        if (this.isFinal)
          this.budgetPlans[i].actual_month_value = this.weightPlan(
            i,
            "actual_month_value"
          );
      });
    },
    addNewPlan() {
      // clear temp index
      this.clearTempPlan();
      if (this.partOneEditMode) {
        this.$vuetify.goTo("#part-one-edit");
      } else {
        this.tempPlan.isNew = true;
        this.partOneEditMode = true;
      }

    },
    editPlan(i) {
      this.partOneEditMode = false;
      this.tempPlan = {
        ...this.removeVModel(this.allPlans[i]),
        temp_index: i,
      };
      this.partOneEditMode = true;
      this.$forceUpdate();
    },
    deletePlan(i) {
      this.allPlans.splice(i, 1);
      this.$forceUpdate();
    },
    editBudgetPlan() {
      this.partOneBudgetEditMode = false;
      this.tempBudgetPlan = this.removeVModel(this.budgetPlans);
      this.partOneBudgetEditMode = true;
      this.$forceUpdate();
    },
    savePlan() {
      // complete 2 pos decimal format
      this.completeTwoPosDecimal("tempPlan");

      // validate WF
      if (!this.validateWF()) return;

      // validate conditions
      let before_value = 0;
      let error = [];
      for (const x of this.tempPlan.project_section_plan_month) {
        if (!isNaN(x.month_value) && parseFloat(x.month_value) < before_value) {
          x.error = true;
          error.push("Value must be greater than previous month value");
        } else {
          x.error = undefined;
          if (x.errorSkipInput) {
            error.push("Cannot skip the input between input values");
          }
        }
        before_value = parseFloat(x.month_value);
      }
      this.$forceUpdate();
      if (error.length > 0) {
        console.log(error);
        return;
      }

      let lastProgress = this.getLastProgress(
        this.tempPlan.project_section_plan_month
      );
      if (!this.tempPlan.isNew) {
        console.log(this.tempPlan);
        // EDIT
        this.allPlans[this.tempPlan.temp_index] = {
          ...this.tempPlan,
          percent: lastProgress,
          temp_index: undefined,
        };
      } else {
        // ADD
        this.allPlans.push({
          p1_activity_name: this.tempPlan.p1_activity_name,
          p1_wf: this.tempPlan.p1_wf,
          project_section_plan_month: this.tempPlan.project_section_plan_month,
          percent: lastProgress,
        });
      }

      this.plotProgressPlanGraphData();
      this.mapWFData();
      this.clearTempPlan();
      this.partOneEditMode = false;
    },
    saveBudgetPlan() {
      this.calcBudgetPlanRate();
      // complete 2 pos decimal format
      //this.completeTwoPosDecimal('tempBudgetPlan')

      // // validate form ต้องกรอกอย่างน้อย 1 รายการ และต้องไม่เป็น 0
      // if (
      //   this.tempBudgetPlan.filter((x) => x.plan_budget !== "").length === 0 ||
      //   this.tempBudgetPlan.filter((x) => x.plan_budget != 0).length === 0
      // ) {
      //   this.$store.commit("General/setModal", {
      //     theme: "warning",
      //     title: "ข้อมูลไม่ครบถ้วน ?",
      //     text: "กรุณากรอกข้อมูลอย่างน้อย 1 รายการ และต้องไม่เป็น 0",
      //     buttonText: "OK",
      //     showCancel: false,
      //   });
      //   return;
      // }

      // // validate ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด
      // if (
      //   this.tempBudgetPlan
      //     .map((x) => parseFloat(x.plan_budget ? x.plan_budget : 0))
      //     .reduce((a, b) => a + b, 0) !==
      //   this.budgetList
      //     .map((x) => parseFloat(x.budget_sum))
      //     .reduce((a, b) => a + b, 0)
      // ) {
      //   this.$store.commit("General/setModal", {
      //     theme: "warning",
      //     title: "ข้อมูลไม่ถูกต้อง ?",
      //     text: "ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด",
      //     buttonText: "OK",
      //     showCancel: false,
      //   });
      //   return;
      // }

      // validate conditions
      //let before_value = 0
      let totalBudget = 0;
      let error = [];
      for (const x of this.tempBudgetPlan) {
        //   x.error = undefined
        //   if (x.errorSkipInput) {
        //     error.push('Cannot skip the input between input values')
        //   }
        //   before_value = parseFloat(x.plan_budget)
        totalBudget += parseFloat(x.plan_budget);
      }
      this.$forceUpdate();
      if (totalBudget > this.budget_amount) {
        this.$store.commit("General/setModal", {
          theme: "error",
          title: "บันทึกไม่สำเร็จ",
          text: "แผนการใช้จ่ายเกินงบประมาณ ไม่สามารถบันทึกได้",
          buttonText: "OK",
          showCancel: false,
        });
        return;
      }
      if (error.length > 0) {
        console.log(error);
        return;
      }

      this.budgetPlans = this.tempBudgetPlan;

      this.partOneBudgetEditMode = false;
    },
    calcBudgetPlanRate(objectName = "tempBudgetPlan") {
      let i = 0;
      this[objectName].forEach((budget) => {
        if (!budget.plan_budget) budget.plan_budget = 0;
        if (i == 0) {
          budget.plan_budget_sum = parseFloat(budget.plan_budget).toFixed(2);
        } else {
          budget.plan_budget_sum = (
            parseFloat(budget.plan_budget) +
            parseFloat(this[objectName][i - 1].plan_budget_sum)
          ).toFixed(2);
        }
        const exactRate = (parseFloat(budget.plan_budget_sum) / parseFloat(this.budget_amount)) * 100;

        budget.plan_budget_rate = (Math.floor(exactRate * 100) / 100).toFixed(2);

        if (parseFloat(budget.plan_budget_sum) == 0)
          budget.plan_budget_rate = null;
        i++;
      });
      console.log("after calc budget rate", this.tempBudgetPlan);
    },
    clearTempPlan() {
      this.tempPlan = this.removeVModel(this.plan_prototype);
      this.error_p1_wf = false;
      this.$forceUpdate();
    },
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    getLastProgress(items) {
      items = this.removeVModel(items);
      if (items && typeof items === "object" && items.length > 0) {
        for (const x of items.reverse()) {
          if (!!x.month_value && x.month_value !== "-") {
            return x.month_value;
          }
        }
      }
      return "-";
    },
    completeTwoPosDecimal(tempName) {
      let i = 0;
      let temp = [];
      let value = "";
      if (tempName === "tempPlan") {
        temp = this[tempName].project_section_plan_month;
        value = "month_value";
      } else {
        temp = this[tempName];
        value = "plan_budget_rate";
      }

      for (const x of temp) {
        x.errorSkipInput = undefined;
        if (!x[value] || isNaN(x[value])) {
          x[value] = null;
          if (i > 0) {
            let hasSomeProgressBefore = false;
            let hasSkipInput = false;
            for (let ind = 0; ind < i; ind++) {
              if (temp[ind][value]) {
                hasSomeProgressBefore = true;
                for (let lastInd = temp.length - 1; lastInd > i; lastInd--) {
                  if (!!temp[lastInd][value]) hasSkipInput = true;
                }
              }
            }

            if (hasSomeProgressBefore) x[value] = "100.00";
            if (tempName === "tempBudgetPlan") x[value] = "0.00";

            if (hasSkipInput) {
              x[value] = null;
              x.errorSkipInput = true;
            }
          }
        } else {
          // no decimal case
          if (!x[value].toString().includes(".")) {
            x[value] += ".00";
          } else {
            // decimal case
            let y = x[value].toString().split(".");
            if (!y[0] && y[0] != "0") {
              y[0] = "0";
            }
            if (!y[1] && y[1] != "0") {
              y[1] = "00";
            }
            // fill zero for 2 position decimal
            if (y.length > 1 && y[1].length === 1) {
              y[1] = y[1].toString() + "0"; // add 0 as string
            }
            // remove after 2 position decimal
            if (y.length > 1 && y[1].length > 2) {
              y[1] = y[1].substring(0, 2);
            }
            x[value] = y[0] + "." + y[1];
            if (x[value] === "0.00") x[value] = null;
          }
        }
        i++;
      }
    },
    validateWF() {
      let error = [];
      let total = 0;
      let editCase =
        !!this.tempPlan.temp_index || this.tempPlan.temp_index === 0;

      // total is 1.00
      if (this.allPlans.length > 0) {
        if (this.allPlans.length === 1) {
          total = this.allPlans[0].p1_wf;
          if (editCase) total = 0;
        } else {
          if (editCase) {
            total = this.allPlans
              .filter((x, i) => i !== this.tempPlan.temp_index)
              .map((x) => x.p1_wf)
              .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
          } else {
            total = this.allPlans.reduce(
              (a, b) => parseFloat(a.p1_wf) + parseFloat(b.p1_wf),
              0
            );
          }
        }

        if (parseFloat(total) >= 1) {
          error.push("WF value cannot over exceed 1.00");
        }
      }

      if (!this.tempPlan.p1_wf || isNaN(this.tempPlan.p1_wf)) {
        error.push("WF value is not correct");
      } else {
        // no decimal case
        if (!this.tempPlan.p1_wf.toString().includes(".")) {
          this.tempPlan.p1_wf += ".00";
        } else {
          // decimal case
          let y = this.tempPlan.p1_wf.toString().split(".");
          if (!y[0] && y[0] != "0") {
            y[0] = "0";
          }
          if (!y[1] && y[1] != "0") {
            y[1] = "00";
          }
          // fill zero for 2 position decimal
          if (y.length > 1 && y[1].length === 1) {
            y[1] = y[1].toString() + "0"; // add 0 as string
          }
          // remove after 2 position decimal
          if (y.length > 1 && y[1].length > 2) {
            y[1] = y[1].substring(0, 2);
          }
          this.tempPlan.p1_wf = y[0] + "." + y[1];
          if (this.tempPlan.p1_wf === "0.00") {
            error.push("WF value is not correct");
          }
        }
        if (this.tempPlan.p1_wf > 1) {
          error.push("WF value must less or equal 1.00");
        }
      }

      if (parseFloat(total) + parseFloat(this.tempPlan.p1_wf) > 1) {
        error.push("WF total value must equal 1.00");
      }

      if (error.length > 0) {
        console.log(error);
        this.error_p1_wf = true;
      } else {
        this.error_p1_wf = false;
      }
      this.$forceUpdate();

      return !this.error_p1_wf;
    },
    totalWF() {
      if (!this.allPlans || this.allPlans.length === 0) return "-";
      let total = this.allPlans
        .map((x) => x.p1_wf)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    weightPlan(index, field = "month_value") {
      let total = [];
      for (const x of this.allPlans) {
        let result = x.project_section_plan_month[index]
          ? parseFloat(x.project_section_plan_month[index][field] * x.p1_wf)
          : 0;
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    addNewBudget() {
      if (this.partTwoEditMode) {
        // clear temp index
        this.tempBudget = {};
        this.$vuetify.goTo("#part-two-edit");
      } else {
        this.partTwoEditMode = true;
      }
      this.tempBudget = {
        isNew : true,
        budget_in_kind: null,
        budget_in_cash: null,
        budget_sci_park: null,
      }
    },
    editBudget(i) {
      this.partTwoEditMode = false;
      this.tempBudget = {
        ...this.removeVModel(this.budgetList[i]),
        tempIndex: i,
        isNew: false,
      };
      this.partTwoEditMode = true;
      this.$forceUpdate();
    },
    deleteBudget(i) {
      this.budgetList.splice(i, 1);
      this.$forceUpdate();
    },
    saveBudget() {
      this.partTwoEditMode = false;
      if (!this.tempBudget.budget_in_cash) this.tempBudget.budget_in_cash = 0.0;
      if (!this.tempBudget.budget_in_kind) this.tempBudget.budget_in_kind = 0.0;
      if (!this.tempBudget.budget_sci_park)
        this.tempBudget.budget_sci_park = 0.0;
      this.tempBudget.budget_sum =
        parseFloat(this.tempBudget.budget_in_kind) +
        parseFloat(this.tempBudget.budget_in_cash) +
        parseFloat(this.tempBudget.budget_sci_park);

      if (!this.tempBudget.isNew) {
        console.log("tempBudget", this.tempBudget);
        // EDIT
        this.budgetList[this.tempBudget.tempIndex] = {
          ...this.tempBudget,
          temp_index: undefined,
        };
      } else {
        // ADD
        this.budgetList.push(this.tempBudget);
      }
      this.tempBudget = {};

      this.calcBudgetAmount();
      this.calcBudgetPlanRate("budgetPlans");
      this.$forceUpdate();
    },
    calcBudgetAmount() {
      this.budget_amount = this.budgetList
        .map((x) => parseFloat(x.budget_sum))
        .reduce((a, b) => a + b, 0);
      console.log("budget_amount", this.budget_amount);
    },
    addNewPlanDetail() {
      this.clearTempProgressPlan();
      this.partThreeEditMode = true;
    },
    saveProgressPlan() {
      let error = [];
      if (this.tempProgressPlan.plan.length === 0) {
        error.push("Select at least 1 month for planning");
        return;
      }
      if (this.tempProgressPlan.temp_index !== undefined) {
        // EDIT
        this.allProgressPlan[this.tempProgressPlan.temp_index] = {
          ...this.tempProgressPlan,
          temp_index: undefined,
        };
      } else {
        // ADD
        this.allProgressPlan.push(this.tempProgressPlan);
      }
      this.clearTempProgressPlan();
      this.partThreeEditMode = false;
    },
    progressPlanCheck(key) {
      if (this.tempProgressPlan.plan.includes(key)) {
        this.tempProgressPlan.plan = this.tempProgressPlan.plan.filter(
          (x) => x !== key
        );
      } else {
        this.tempProgressPlan.plan.push(key);
      }
    },
    clearTempProgressPlan() {
      this.tempProgressPlan = this.removeVModel(this.progressPlan_prototype);
      this.$forceUpdate();
    },
    editProgressPlan(index) {
      this.partThreeEditMode = false;
      this.tempProgressPlan = {
        ...this.removeVModel(this.allProgressPlan[index]),
        temp_index: index,
      };
      this.partThreeEditMode = true;
      this.$forceUpdate();
    },
    setupBudgetYearMonth() {
      // 544 (minus 543 to BC and minus 1 to fiscal year)
      let ym = new Date((this.fiscalYear - 544).toString() + "-10");
      let countMonths = 12;
      if (this.isFinal && this.masterData.form_c?.progress_month && this.masterData.form_c?.progress_month > 12) {
        countMonths += this.masterData.form_c.progress_month - 12;
      }
      for (let i = 0; i < countMonths; i++) {
        this.shortMonths.push({
          key: i + 1,
          month: format(ym, "MMM", { locale: th }),
          year: (parseInt(ym.toISOString().substr(0, 7).split("-")[0]) + 543)
            .toString()
            .slice(2),
          
        });
        this.plan_prototype.project_section_plan_month.push({
          year_month: ym.toISOString().substr(0, 7),
          month_value: "",
        });
        this.budget_plan_prototype.push({
          year_month: ym.toISOString().substr(0, 7),
          month_value: "",
          plan_budget: "",
          plan_budget_rate: "",
        });
        ym = new Date(ym.setMonth(ym.getMonth() + 1));
      }
    },
    getCurrIndex() {
      let ind = 0;
      for (const x of this.allPlans) {
        let i = 0;
        console.log("x", x);
        for (const y of x.project_section_plan_month) {
          console.log("y", y);
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean") return correctIndex;
          i++;
        }
        ind++;
      }
    },
    isInCorrectRange(item, index = null) {
      let today = new Date();
      let currentMonth = today.getMonth();
      let thisMonth = new Date(item.year_month).getMonth();

      let isCorrectCase = thisMonth === currentMonth;

      // for return active yearMonth index
      if (isCorrectCase && index !== null) return index;

      return isCorrectCase;
    },
    validateInput(index, value) {
      if (!isNaN(value) && value >= 0 && value <= 100) {
        // if (index > 0) {
        //   let previousValue = this.tempPlan.project_section_plan_month[index - 1]?.month_value;
        //   if (previousValue && value >= previousValue) {
        //     this.$set(this.tempPlan.project_section_plan_month[index], 'month_value', value);
        //   } else {
        //     this.$set(this.tempPlan.project_section_plan_month[index], 'month_value', previousValue);
        //   }
        // } else {
        this.$set(
          this.tempPlan.project_section_plan_month[index],
          "month_value",
          value
        );
        // }
      } else {
        if (!isNaN(value)) {
          if (value > 100) {
            this.$set(
              this.tempPlan.project_section_plan_month[index],
              "month_value",
              100
            );

          } else {

            this.$set(
              this.tempPlan.project_section_plan_month[index],
              "month_value",
              0
            );
          }
        } else {  
          this.$set(
            this.tempPlan.project_section_plan_month[index],
            "month_value",
            null
          );
        }
      }
      this.$forceUpdate();
    },
      validatePlanBudget() {
      let isCorrect = true;
      // validate form ต้องกรอกอย่างน้อย 1 รายการ และต้องไม่เป็น 0
      if (Object.keys(this.budgetPlans).length === 0) {
        return  false;
      }
      if (
        this.budgetPlans?.filter((x) => x.plan_budget !== "")
          .length === 0 ||
        this.budgetPlans?.filter((x) => x.plan_budget != 0)
          .length === 0 ||
        this.budgetPlans?.filter((x) => x.plan_budget != "0.00")
          .length === 0
      ) {
        isCorrect = false;
      }

      // validate ผลรวมแผนการใช้จ่ายต้องเท่ากับงบประมาณที่กำหนด
      if (
        this.budgetPlans
          ?.map((x) => parseFloat(x.plan_budget ? x.plan_budget : 0))
          .reduce((a, b) => a + b, 0) !==
        this.budgetList
          ?.map((x) => parseFloat(x.budget_sum))
          .reduce((a, b) => a + b, 0)
      ) {

        isCorrect = false;
      }
      
      return isCorrect;
    },
      nowIndex(month, year) {
      
        const thaiShortMonthMap = {
          'ม.ค.': 0, 'ก.พ.': 1, 'มี.ค.': 2, 'เม.ย.': 3,
          'พ.ค.': 4, 'มิ.ย.': 5, 'ก.ค.': 6, 'ส.ค.': 7,
          'ก.ย.': 8, 'ต.ค.': 9, 'พ.ย.': 10, 'ธ.ค.': 11
        };
        const monthNumber = thaiShortMonthMap[month];
        if (monthNumber === undefined) return false; // fail-safe

        const buddhistYear = parseInt(year); // 68
        const gregorianYear = buddhistYear + 2000 - 543; // 68 + 2000 - 543 = 1525 (wrong) ❌

        // Correct conversion:
        const currentYear = new Date().getFullYear(); // e.g., 2025
        const buddhistCurrentYear = currentYear + 543; // e.g., 2568

        const yearFull = (buddhistYear > 2500) ? buddhistYear - 543 : buddhistYear + 2500 - 543;
        // Or easier if always 2-digit: assume 68 => 2568 => 2025
        const yearParsed = buddhistYear + 2500 - 543; // 2025

        const planDate = new Date(yearParsed, monthNumber, 1);
        const currentMonthStart = new Date();
        currentMonthStart.setDate(1);
        currentMonthStart.setHours(0, 0, 0, 0);

        return planDate < currentMonthStart;
      }
  },
};
</script>

<style lang="scss">
.job_delivery_details_form {
  label {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }

  .v-input__slot,
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: 40px !important;
    border-radius: 30px;
  }

  .v-text-field--full-width .v-input__prepend-outer,
  .v-text-field--full-width .v-input__prepend-inner,
  .v-text-field--full-width .v-input__append-inner,
  .v-text-field--full-width .v-input__append-outer,
  .v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field--enclosed .v-input__append-inner,
  .v-text-field--enclosed .v-input__append-outer {
    margin-top: 8px !important;
  }

  .v-input--is-readonly:not(.picker-field) .v-input__slot {
    background-color: #ffffff !important;
  }

  i.v-icon.notranslate.mdi.mdi-calendar.theme--light {
    color: #f7941d !important;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }
}
</style>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #fafafa;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: "Tahoma", sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
</style>
